/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) SideGrid View Icon component.
 */
export const SideGridViewIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0.75 3V21H23.25V3H0.75ZM2.25 4.5H7.5V19.5H2.25V4.5ZM21.75 19.5H9.5V4.5H21.75V19.5Z' fill={iconColor} />
    </svg>
  );
};

export default SideGridViewIcon;
